










import { Component, Vue } from "vue-property-decorator";
import { SettingsModal } from "@/components/modals";

@Component({
  components: {
    SettingsModal,
  },
})
export default class HeaderSettings extends Vue {
  private showModal = false;

  public toggleModal() {
    this.showModal = !this.showModal;
  }
}
